import { useEffect, useRef } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Callback = (...args: any) => any

export const useOnce = (callback: Callback): void => {
  const calledOnce = useRef(false)

  useEffect(() => {
    if (!calledOnce.current) {
      calledOnce.current = true
      callback()
    }
  }, [callback, calledOnce])
}
